import React, { useEffect, useState } from "react";
import { Card, Spin, Space } from "antd";
import apiClient from "../api_client";

const CoquillesTable = ({ 
  url,
  title = null,
  labelAll = "Nb coquilles", 
  labelOk = "Nb coquilles OK", 
  labelNok = "Nb coquilles KO",
  labelExtra = null,
  showExtra = false,
  refreshTrigger = 0,
  vertical = false,
  disableAutoRefresh = false
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(null);

  const fetchData = async () => {
    try {
      const res = await apiClient.get(url);
      setData(res.data);
      setLastUpdate(new Date().toLocaleTimeString());
    } catch (err) {
      console.error("Erreur lors du chargement :", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!url) return;
    fetchData();
    if (!disableAutoRefresh) {
      const interval = setInterval(fetchData, 2000);
      return () => clearInterval(interval);
    }
  }, [url, disableAutoRefresh]);

  // Rafraîchir quand refreshTrigger change
  useEffect(() => {
    if (refreshTrigger > 0 && url) {
      fetchData();
    }
  }, [refreshTrigger, url]);

  return (
    <Card
      title={title ? (
        <div style={{ 
          textAlign: "center", 
          fontSize: "15px", 
          fontWeight: "bold",
          color: "#1677ff",
          letterSpacing: "1px",
          textTransform: "uppercase"
        }}>
          {title}
        </div>
      ) : null}
      bordered={true}
      style={{
        width: "100%",
        margin: 0,
        padding: 0,
        background: "#fff",
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        borderRadius: title ? "4px" : 0,
        border: title ? "1px solid #d9d9d9" : "none",
      }}
      bodyStyle={{
        margin: 0,
        padding: title ? "16px 12px" : "8px 0",
      }}
      headStyle={title ? {
        background: "#fafafa",
        borderBottom: "1px solid #d9d9d9",
        borderRadius: "4px 4px 0 0",
        color: "#262626",
        padding: "10px 12px",
      } : {
        display: "none",
      }}
    >
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px 0" }}>
          <Spin />
        </div>
      ) : (
        <Space direction={vertical ? "vertical" : "horizontal"} size={vertical ? "middle" : "large"} style={{ width: "100%", justifyContent: "center" }}>
          {/* Statistique All/DSP */}
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "11px", color: "#8c8c8c", marginBottom: "4px" }}>
              {labelAll}
            </div>
            <div style={{ 
              fontSize: "24px", 
              fontWeight: "600",
              color: "#262626"
            }}>
              {data?.all ?? 0}
            </div>
          </div>

          {/* Statistique OK */}
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "11px", color: "#8c8c8c", marginBottom: "4px" }}>
              {labelOk}
            </div>
            <div style={{ 
              fontSize: "24px", 
              fontWeight: "600",
              color: vertical ? "#52c41a" : "#262626"
            }}>
              {data?.ok ?? 0}
            </div>
          </div>

          {/* Statistique NOK */}
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "11px", color: "#8c8c8c", marginBottom: "4px" }}>
              {labelNok}
            </div>
            <div style={{ 
              fontSize: "24px", 
              fontWeight: "600",
              color: vertical ? "#ff4d4f" : "#262626"
            }}>
              {data?.nok ?? 0}
            </div>
          </div>

          {/* Statistique Extra (IV indispo) */}
          {showExtra && labelExtra && (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "11px", color: "#8c8c8c", marginBottom: "4px" }}>
                {labelExtra}
              </div>
              <div style={{ 
                fontSize: "24px", 
                fontWeight: "600",
                color: vertical ? "#fa8c16" : "#262626"
              }}>
                {data?.iv_indispo ?? 0}
              </div>
            </div>
          )}
        </Space>
      )}
    </Card>
  );
};

export default CoquillesTable;
